<template>
  <section>
    <!--工具条-->
    <div class="toolbar-container">
      <div class="button-group">
        <toolbar :buttonList="buttonList" @callFunction="callFunction">
        </toolbar>
        <el-button class="upload-but" type="primary" @click="Uploadfile">上传</el-button>
      </div>
      <el-col :span="6" style="margin-left: 150px;">
        <label><span style="width: 60%;">选择考核：</span></label>
        <el-select v-model="defCheck" filterable placeholder="请选择对应考核" @change="checkchange">
          <el-option v-for="item in checks" :key="item.Id" :label="item.Name" :value="item.Id">
          </el-option>
        </el-select>
      </el-col>
    </div>

    <el-table :data="temples" border v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
      ref="table" class="custom-tbl" style="width: 100%">
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="FileName" label="文件名" width=""></el-table-column>
      <el-table-column prop="Path" label="文件路径" width="350px"></el-table-column>
      <el-table-column prop="Format" label="文件格式" width=""></el-table-column>
      <el-table-column prop="FileVersion" label="文件版本号" width=""></el-table-column>
      <el-table-column prop="CreateTime" label="上传时间" width=""></el-table-column>
      <el-table-column prop="CreateBy" label="上传人" width=""></el-table-column>
      <el-table-column fixed="right" label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">查看详情</el-button>
          <el-button @click="downTemplate(scope.row)" type="text" size="small">下载模板</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination class="toolbar" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="page" :page-size="pageSize" :page-sizes="[50, 100, 200]"
      layout="total, sizes, prev, pager, next, jumper" :total="total">

    </el-pagination>


    <el-dialog title="明细项上传" :visible.sync="dialogUpload" @open="loadDropdownData" :width="'800px'"
      :before-close="handleclose" :destroy-on-close="true" append-to-body>
      <el-select v-model="moduls.Id" @change="handleSelectionid" filterable placeholder="模块项目"
        :style="{ width: '600px', height: '40px' }">
        <el-option v-for=" item in moduls " :key="item.Id" :label="`${item.StIndex} -- ${item.Stoverview}`"
          :value="item.Id" style="max-width: 600px;" :title="`${item.StIndex} ${item.Stoverview}`">
        </el-option>
        <!-- :label="item.Stoverview" -->
      </el-select>
      <el-divider></el-divider>
      <el-transfer :data="checkedtaiList" :render-content="renderFunc" :titles="['可选明细项', '已选明细项']" :format="{
        noChecked: '${total}',
        hasChecked: '${checked}/${total}'
      }
        " filterable :filter-method="filterMethod" filter-placeholder="请输入明细项" v-model="checkedtailData"
        @change="handleChange" class="custom-transfer">

      </el-transfer>
      <!-- 展示所选值 -->
      <!-- <div>
        <h3>已选明细项:</h3>
        <ul>
          <li v-for="item in selectedItems" :key="item.Id">{{ item.label }}</li>
        </ul>
      </div> -->
      <el-divider></el-divider>
      <div class="footer" style="display: flex; align-items: center;">
        <el-button type="primary" @click="showDetails" style="margin-left: 100px;">上传明细详情</el-button>
        <el-upload ref="upload" class="upload-demo" :action="fileAdress" :limit="1" :data="uploadData"
          :on-success="handleSuccess" :on-error="handleError" :before-upload="beforeUpload" :headers="myHeaders"
          :on-change="uploadChange">
          <el-button size="medium" type="primary" style="margin-left: 300px;">点击上传</el-button>
        </el-upload>
      </div>

      <p v-if="errorMessage" style="color: red;">{{ errorMessage }}</p>
      <el-divider></el-divider>
    </el-dialog>


    <el-dialog title="明细项详情" :visible.sync="dialogcheckdetail">
      <div>
        <el-table :data="checkdetail">
          <el-table-column prop="StIndex" label="标准序号" width="150">
          </el-table-column>
          <el-table-column prop="ReviewMethod" label="评审方法" width="450">
          </el-table-column>
          <el-table-column prop="Score" label="分值" width="150">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog title="上传明细" :visible.sync="dialogshangcdetail" width="60%" :destroy-on-close="true">
      <div>
        <el-table :data="CheckponintItemDto">
          <el-table-column prop="AssessmentIndes" label="考核项序号" width="150">
          </el-table-column>
          <el-table-column prop="ReviewPoints" label="考核项评审方法" width="450">
          </el-table-column>
          <el-table-column prop="AssessmentdetailsIndex" label="考核细项序号" width="150">
          </el-table-column>
          <el-table-column prop="AssementdetailsScore" label="考核细项分值" width="150">
          </el-table-column>
          <el-table-column prop="ReviewMethod" label="考核细项评审方法" width="200">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {
  GetChecks,
  GetFiletemplatesPage,
  Getcheckmodules,
  GetcheckdetailsByid,
  RemoveFiletemplate,
  GetFiletemplechecdetail,
  Downtemplate,
  GetcheckpointitemBydetalids,
} from "../../api/RatingManage/RatingManage";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import * as api from '../../api/api';
export default {
  components: { Toolbar },
  data () {
    return {
      fileAdress: api.BaseApiUrl + "/api/RatingManage/AddFiletemplate",
      myHeaders: null,
      selectedid: 0,//下拉框选中的值
      modulid: "",
      filters: {
        name: "",
      },
      temples: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      pageSize: 50,
      listLoading: false,
      sels: [], //列表选中列
      dialogUpload: false,
      moduls: [], //存储所有可选的模块
      checkedtailData: [],//用于双向绑定选择的数据
      checkedtaiList: [],//数据源
      isResouceShow: 0,
      errorMessage: '',
      uploadData: {
        remark: '',//备注
        CheckedIdstr: "",//明细id列表
      },
      selectedItems: [],//选中的明细项
      checkdetail: [],//明细详情
      dialogcheckdetail: false,
      defCheck: "",
      checks: [],
      detailsIds: [],//选中的明细项Id
      dialogshangcdetail: false,
      CheckponintItemDto: [],//上传明细详情
    }
  },
  created () {
    this.myHeaders = { "Authorization": "Bearer " + this.$store.state.token };
  },
  methods: {
    async getchecks () {
      await GetChecks().then((res) => {
        this.checks = res.data.response;
        if (this.checks == null || this.checks.length === 0) {
          this.$message({
            type: 'warning',
            message: '请先创建考核'
          });
          return
        }
        else
          this.defCheck = this.checks[0].Id;

      });
    },
    filterMethod (query, item) {
      return item.label.indexOf(query) > -1;
    },
    //点击上传文件
    async Uploadfile () {
      console.log(this.defCheck);
      await this.getchekmodules();
      if (this.moduls == null || this.moduls.length === 0) {
        this.$message({
          message: '当前的考核没有模块数据,请先创建模块',
          type: 'warning'
        });
        return;
      }
      this.dialogUpload = true
    },
    //选中的数据
    handleChange (value) {
      // 处理穿梭框选择变化的逻辑
      console.log('选中的明细项：', value);
      this.uploadData.CheckedIdstr = value;
      let newSelectedItems = this.checkedtaiList.filter(item => value.includes(item.key));
      this.selectedItems = [
        ...this.selectedItems.filter(item => value.includes(item.key)),
        ...newSelectedItems.filter(item => !this.selectedItems.some(existingItem => existingItem.key === item.key))
      ];
      console.log(JSON.stringify(this.selectedItems) + "选中的明细项目");
      this.detailsIds = [];
      for (const item of this.selectedItems) {
        this.detailsIds.push(item.key);
      }
      console.log("选中的明细项目id" + this.detailsIds);
    },
    dialogCheck (selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow (val) {
      console.log(val + "当前选中的值");
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction (item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
          new Date(row.CreateTime),
          "yyyy-MM-dd hh:mm:ss"
        );
    },
    formatModifyTime: function (row, column) {
      return !row.ModifyTime || row.ModifyTime == ""
        ? ""
        : util.formatDate.format(
          new Date(row.ModifyTime),
          "yyyy-MM-dd hh:mm:ss"
        );
    },
    handleCurrentChange (val) {
      this.page = val;
      this.gettemplates();
    },
    gettemplates () {
      let para = {
        page: this.page,
        key: this.filters.name,
        PageSize: this.pageSize,
        CheckId: this.defCheck,
      };
      this.listLoading = true;
      GetFiletemplatesPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.temples = res.data.response.data;
        this.listLoading = false;
      });
    },
    async getcheckpointitembydetalids () {
      let para = this.detailsIds;
      await GetcheckpointitemBydetalids(para).then((res) => {
        if (res.data.success) {
          console.log("查询成功" + JSON.stringify(res.data.response));
          this.CheckponintItemDto = res.data.response;
        }
      });
    },
    //点击查看明细
    showDetails () {
      //选中的明细为空
      if (this.detailsIds.length === 0) {
        this.CheckponintItemDto = [];
      }
      this.dialogshangcdetail = true;
      this.getcheckpointitembydetalids();

    },
    async getchekmodules () {
      let para = {
        checkId: this.defCheck,
      };
      await Getcheckmodules(para).then((res) => {
        if (res.data.success) {
          this.moduls = res.data.response;
        }

      });
    },
    getcheckdetailsbyid () {
      let para = {
        moduleId: this.selectedid
      };
      GetcheckdetailsByid(para).then((res) => {
        this.checkedtaiList = res.data.response.map(item => {
          return {
            key: item.Id,
            label: item.ReviewMethod,
          };

        });

      });
    },
    getfiletemplechecdetail (id) {
      let para = { id: id };
      GetFiletemplechecdetail(para).then((res) => {
        this.checkdetail = res.data.response;
      });
    },
    downfiletemplate (id) {
      let para = { id: id };
      Downtemplate(para).then((res) => {
        if (res && res.data) {
          // 创建Blob对象
          const blob = new Blob([res.data], { type: 'application/octet-stream' });
          // 创建一个链接元素
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          // 从响应头中获取文件名
          const contentDisposition = res.headers['content-disposition'];
          let fileName = 'downloaded-file';
          if (contentDisposition) {
            const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
              fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''));
            }
          }
          // 检查是否支持msSaveOrOpenBlob方法
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // Edge特定的文件下载方法
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            // 创建一个链接元素
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            // 触发下载
            document.body.appendChild(link);
            link.click();
            // 移除链接元素
            document.body.removeChild(link);
            // 释放URL对象
            window.URL.revokeObjectURL(url);
          }
        }
      })
        .catch((error) => {
          console.error('下载文件失败:', error);

        });
    },
    loadDropdownData () {
      this.errorMessage = "";
    },
    handleSizeChange (size) {
      this.pageSize = size;
      this.page = 1; // 当更改分页大小时，重置为第一页
      this.gettemplates();

    },
    handleSelectionid () {

      this.selectedid = this.moduls.Id;
      if (this.selectedid > 0) {
        this.getcheckdetailsbyid();
      }
    },
    handleSuccess (response, file, fileList) {
      // 文件上传成功的处理逻辑
      if (response && response.status === 200) {
        // 文件上传成功且后端返回状态码为200
        this.$message.success('文件上传成功');
        // 在这里删除选中的明细项目
        this.selectedItems = [];
        this.checkedtaiList = [];
        this.checkedtailData = [];
        this.uploadData.CheckedIdstr = [];
        this.dialogUpload = false;
        this.detailsIds = [];
        this.CheckponintItemDto = [];
        this.gettemplates();
      } else {
        // 文件上传成功但后端返回了错误状态码
        this.$message.error('文件上传失败：服务器错误');
      }
    },
    handleError (err, file, fileList) {
      // 文件上传失败的处理逻辑
      if (file.response && file.response.msg) {
        this.$message.error(file.response.msg);
      } else {
        this.$message.error('文件上传失败，请重试。');
      }
      // 删除上传失败的文件
      this.removeFile(file);
    },
    uploadChange (file, fileList) {
      if (file.status === 'error') {
        console.error('File status is error:', file);
        this.handleError(new Error('上传文件失败'), file, fileList);
      } else if (file.response && file.response.status === 500) {
        console.error('文件上传失败', file.response.msg);
        this.handleError(new Error(file.response.msg || '上传文件失败'), file, fileList);
      }
    },
    beforeUpload (file) {
      console.log(file.type + "文件格式");
      //判断上传的文件是否符合格式
      const allowedTypes = [
        'image/jpeg', 'image/png', 'image/gif',  // 图片格式
        'application/pdf',                       // PDF 格式
        'application/msword',                   // Word 文档
        'text/plain',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',  // Excel 文件（.xlsx）
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'  // Word 文档（.docx）
      ];
      if (!allowedTypes.includes(file.type)) {
        this.errorMessage = '无效的文件格式,请上传有效的文件(JPEG, PNG, GIF, PDF, DOC, DOCX,XLSX,TEXT)';
        return false;  // 阻止文件上传
      }
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.errorMessage = '文件大小不能超过 50MB。';
        return false;  // 阻止文件上传
      }
      this.errorMessage = '';
      return true; // 返回true表示允许上传，返回false表示取消上传
    },
    removeFile (file) {
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();  // 清除所有文件
      } else {
        console.error('Upload component reference not found');
      }

    },
    //删除
    handleDel () {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { filetempId: row.Id };
          RemoveFiletemplate(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });

            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.gettemplates();
          });
        })
        .catch(() => { });
    },
    handleClick (row) {
      this.getfiletemplechecdetail(row.Id);
      this.dialogcheckdetail = true;
    },
    renderFunc (h, option) {
      return h('el-tooltip', {
        props: {
          content: option.label,
          placement: 'top',
        }
      }, [
        h('span', { class: 'long-text' }, option.label)
      ]);
    },
    //下载模板
    downTemplate (row) {
      console.log("下载模板" + row.Id)
      this.downfiletemplate(row.Id);
    },
    //关闭diag前回调
    handleclose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          // 在这里删除选中的明细项目
          this.selectedItems = [];
          this.checkedtaiList = [];
          this.checkedtailData = [];
          this.uploadData.CheckedIdstr = [];
          this.moduls = [];
          this.detailsIds = [];
          this.CheckponintItemDto = [];
          done();
        })
        .catch(_ => { });
    },
    checkchange (defCheck) {
      console.log("当前选中的值" + defCheck);
      this.defCheck = defCheck;
      this.gettemplates();
    },
    async initializeDefCheck () {
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      this.buttonList = getButtonList(this.$route.path, routers);
      await this.getchecks();
      this.gettemplates();
    },
  },
  mounted () {
    this.initializeDefCheck();
  },
}
</script>

<style lang="less" scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

// .upload-demo {
//   margin: 20px 0;
// }

.toolbar-container {
  display: flex;

  /* 垂直居中对齐 */
  width: 100%;
}

.button-group {
  display: flex;
  align-items: center;
  /* 垂直居中对齐 */
}

.upload-but {
  margin-left: -8px;
  margin-top: -22px;
  /* 设置上传按钮与左侧按钮之间的间距 */
  padding: 12px 20px;
  /* 内边距，根据需要调整 */
  font-size: 15px;
  font-weight: 500;
  /* 字体大小，根据需要调整 */
  line-height: 1;
  /* 行高，根据需要调整 */
  height: 38px;
  /* 统一按钮高度，请根据其他按钮的实际高度进行调整 */
  display: flex;
  align-items: center;
  /* 确保上传按钮内部内容垂直居中 */
}

.custom-transfer {
  height: 450px;
}

.custom-transfer ::v-deep .el-transfer-panel {
  max-height: none !important;
  height: 400px !important;
  /* 移除 max-height 限制 */
  /* 自定义高度 */
}

.custom-transfer ::v-deep .el-transfer-panel__body {
  height: 400px !important;
  /* 确保 body 部分也有相同的高度 */
}

::v-deep .el-transfer-panel__list {
  height: 294px !important;
}

.long-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
